<template>
    <div>
        <div class="group-head">
            <div class="title MR10"><span class="el-icon-data-analysis"></span> 汇总排名</div>
            <div class="sub-title"><router-link class="color-theme"
                    :to="`/report/sales/surrounding?timeStart=${daterange[0]} 00:00:00&timeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
            </div>
        </div>
        <el-row :gutter="15" v-loading="dataLoading" class="rank-box">
            <template v-if="data">
                <el-col :sm="12" :md="8" class="MT15">
                    <el-card shadow="never">
                        <div slot="header">
                            类别销售
                        </div>
                        <div v-if="list1.length > 0" class="rank">
                            <template v-for="(item, index) in list1">
                                <div v-if="index < 5" :key="index" class="item">
                                    <!-- <el-image class="logo">
                                        <div slot="error" class="image-slot" :class="[index == 0 ? 'color-danger' : '']">
                                            <span class="el-icon-money"></span>
                                        </div>
                                    </el-image> -->
                                    <div class="info" :class="[index == 0 ? 'color-danger' : '']">
                                        <div class="name">{{ item.goodsCategoryName }}</div>
                                        <div class="amount">销售额：{{ item.amount || 0 }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="8" class="MT15">
                    <el-card shadow="never">
                        <div slot="header">
                            专辑唱片销售
                        </div>
                        <div v-if="list2.length > 0" class="rank">
                            <div v-for="(item, index) in list2" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{ index + 1 }}</span>
                                <div class="info">
                                    <el-tooltip class="name" :content="item.goodsName" placement="top">
                                        <span class="ellipsis">{{ item.goodsName }}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{ item.amount }}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="8" class="MT15">
                    <el-card shadow="never">
                        <div slot="header">
                            服饰销售
                        </div>
                        <div v-if="list3.length > 0" class="rank">
                            <div v-for="(item, index) in list3" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{ index + 1 }}</span>
                                <div class="info">
                                    <el-tooltip class="name" :content="item.goodsName" placement="top">
                                        <span class="ellipsis">{{ item.goodsName }}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{ item.amount }}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="8" class="MT15">
                    <el-card shadow="never">
                        <div slot="header">
                            纪念品销售
                        </div>
                        <div v-if="list4.length > 0" class="rank">
                            <div v-for="(item, index) in list4" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{ index + 1 }}</span>
                                <div class="info">
                                    <el-tooltip class="name" :content="item.goodsName" placement="top">
                                        <span class="ellipsis">{{ item.goodsName }}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{ item.amount }}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="8" class="MT15">
                    <el-card shadow="never">
                        <div slot="header">
                            配饰销售
                        </div>
                        <div v-if="list6.length > 0" class="rank">
                            <div v-for="(item, index) in list6" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{ index + 1 }}</span>
                                <div class="info">
                                    <el-tooltip class="name" :content="item.goodsName" placement="top">
                                        <span class="ellipsis">{{ item.goodsName }}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{ item.amount }}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="8" class="MT15">
                    <el-card shadow="never">
                        <div slot="header">
                            其他销售
                        </div>
                        <div v-if="list5.length > 0" class="rank">
                            <div v-for="(item, index) in list5" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{ index + 1 }}</span>
                                <div class="info">
                                    <el-tooltip class="name" :content="item.goodsName" placement="top">
                                        <span class="ellipsis">{{ item.goodsName }}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{ item.amount }}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </template>
        </el-row>
    </div>
</template>

<script>
export default {
    props: {
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            data: null,
            dataLoading: false,
            list1: [],
            list2: [],
            list3: [],
            list4: [],
            list5: [],
            list6: [],
        }
    },
    mounted() {
        this.getData();
    },
    watch: {
        daterange(v1, v2) {
            if (v2.length > 0 && v1 != v2) {
                this.getData();
            }
        }
    },
    methods: {
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/goodsdata/rank2",
                method: "POST",
                data: {
                    start: this.daterange.length > 0 ? this.daterange[0] : "",
                    end: this.daterange.length > 1 ? this.daterange[1] : "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.list1 = result.find(v => v.type == -1).list;
                        this.list2 = result.find(v => v.type == 1).list;
                        this.list3 = result.find(v => v.type == 2).list;
                        this.list4 = result.find(v => v.type == 3).list;
                        this.list5 = result.find(v => v.type == 4).list;
                        this.list6 = result.find(v => v.type == 5).list;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
    }
}
</script>
<style lang="scss" scoped></style>